import "./dotindicator.scss";

interface IDotIndicator {
    size?: string
}

const DotIndicator = ({size}:IDotIndicator) => {
    return(
        <div className="Dot-Indicator" style={{width: size,height:size}}></div>
    );
}

export default DotIndicator;